const toInteger = value => (isNaN(value) ? 0 : Math.round(Number(value), 0))

export default toInteger
